import { render, staticRenderFns } from "./removeshipment.vue?vue&type=template&id=371c7054&"
import script from "./removeshipment.vue?vue&type=script&lang=js&"
export * from "./removeshipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports